import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteStateCodeModel } from 'src/app/models/excluded-statecode/excluded-state-code.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { ExcludedStatecodeService } from 'src/app/services/excluded-statecode.service';

@Component({
  selector: 'app-exclude-statecode-delete',
  templateUrl: './exclude-statecode-delete.component.html',
  styleUrls: ['./exclude-statecode-delete.component.css']
})
export class ExcludeStatecodeDeleteComponent implements OnInit {
  deleteStateCode: DeleteStateCodeModel = new DeleteStateCodeModel();
  Loader: boolean = false;
  constructor(private excludedStatecodeService: ExcludedStatecodeService, private modalService: NgbModal, private alertify: AlertifyService) { }

  ngOnInit() {
    this.excludedStatecodeService.getStateCodeId.subscribe((id: string) => {
      this.deleteStateCode.Id = +id;
    });
  }

  DeleteStateCode() {
    this.Loader = true;
    this.excludedStatecodeService.DeleteStateCode(this.deleteStateCode)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.alertify.success(responseBody.responseMessage);
          this.modalService.dismissAll();
          this.Loader = false;
        } else {
          this.Loader = false
        }
      })
  }

  onCancel() {
    this.modalService.dismissAll();
  }
}
